// extracted by mini-css-extract-plugin
export default {"quote-source":"Social_quote-source__tTnD5","quote-source__person":"Social_quote-source__person__8ziR8","quote":"Social_quote__FeE4s"};